import devCustom from './components/devCustom.vue';
export default {
  components: {
    devCustom: devCustom
  },
  data: function data() {
    return {
      //游戏区服
      formId: 139
    };
  },
  methods: {}
};